// This file is auto-generated don't edit it!
import { Component } from '@angular/core';

@Component({
    selector: 'ui-panel-docs',
    templateUrl: './panel.docs.generated.html',
})
export class UIPanelDocs { }
